import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { AuthProvider } from '@/features/auth/auth-provider'
import { toAppError } from '@/lib/errors'
import { router } from './router'
import { UpdatePrompt } from './update-prompt'
import { OfflineBanner } from './offline-banner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, error) => {
        const code = toAppError(error).code
        if (['FORBIDDEN', 'UNAUTHENTICATED', 'NOT_FOUND', 'BUSINESS_NOT_FOUND', 'INVALID_TOKEN', 'PGRST116'].includes(code)) return false
        return count < 2
      },
      refetchOnWindowFocus: true,
    },
    mutations: {
      // Mutations are never retried automatically: booking/approval writes
      // must be explicit (idempotency keys protect the ones that can repeat).
      retry: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      const e = toAppError(error)
      if (e.code === 'UNKNOWN' || e.code === 'INTERNAL') console.error('[mutation]', e.code, e.details)
    },
  }),
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OfflineBanner />
        <RouterProvider router={router} />
        <UpdatePrompt />
        <Toaster position="top-center" richColors closeButton toastOptions={{ duration: 4500 }} />
      </AuthProvider>
    </QueryClientProvider>
  )
}
